var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59961 0.100098C3.00688 0.100098 0.0996094 3.00737 0.0996094 6.6001C0.0996094 10.1928 3.00688 13.1001 6.59961 13.1001C10.1923 13.1001 13.0996 10.1928 13.0996 6.6001C13.0996 3.00737 10.1923 0.100098 6.59961 0.100098ZM6.59961 12.0128C3.60961 12.0128 1.17506 9.5901 1.16325 6.6001C1.16325 3.6101 3.58597 1.17555 6.57597 1.16373C9.56597 1.16373 12.0005 3.58646 12.0123 6.57646C12.0123 6.57646 12.0123 6.58828 12.0123 6.6001C12.0123 9.5901 9.58961 12.001 6.59961 12.0128Z",
    fill: "#616063",
    stroke: "#616063",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19061 6.35196V3.6456C7.19061 3.31469 6.93061 3.05469 6.5997 3.05469C6.26879 3.05469 6.00879 3.31469 6.00879 3.6456V6.60014C6.00879 6.67105 6.00879 6.75378 6.00879 6.82469C6.04424 6.8956 6.09152 6.95469 6.13879 7.01378L7.8997 8.72741C8.11243 8.95196 8.47879 8.96378 8.70333 8.75105C8.70333 8.75105 8.71515 8.73923 8.72697 8.72741C8.95152 8.51469 8.96333 8.14832 8.75061 7.92378C8.75061 7.92378 8.73879 7.91196 8.72697 7.90014L7.19061 6.35196Z",
    fill: "#616063",
    stroke: "#616063",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.b93458e0f9de7bef77168a501546d46c.svg";
export { ForwardRef as ReactComponent };